import React from "react";
import uuid from "uuid";
import $ from "jquery";
import { control } from "react-validation";

import { ValidationContext } from "../validation/ValidationContext";

import Errors from "./Error";

class LookUpSelect2 extends React.Component {
  constructor(props) {
    super(props);

    this.selectInput = React.createRef();
    this.selectId = uuid();
  }

  componentDidMount() {
    //const selectInput = this.selectInput.current;
    const selectInput = $(`#${this.selectId}`);
    $(selectInput)
      .select2({
        placeholder: "Select language",
      })
      .on("select2:open", () => {
        $(".select2-results__options").niceScroll({
          cursorcolor: "#d8d8d8",
          cursorminheight: 56,
          railpadding: { top: 0, right: 0, left: 2, bottom: 0 },
        });
      })
      .on("change", (e) => {
        // this ensures the change via select2 triggers
        // the state change for your component
        this.props.onHandleChange(e.target.name, e.target.value);
      });
  }

  componentWillUnmount() {
    const selectInput = $(`#${this.selectId}`);
    $(selectInput).select2("destroy");
  }

  render() {
    const {
      options,
      value,
      validations,
      name,
      error,
      isChanged,
      frontErrors,
      category,
      field,
      onHandleChange,
    } = this.props;

    return (
      <ValidationContext.Consumer>
        {({ backErrors, hideError }) => (
          <div style={{ marginTop: "10px" }}>
            <select
              id={this.selectId}
              value={value}
              name={name}
              validations={validations}
              onChange={(value, state, props) => {
                onHandleChange(props.name, value.value);
                hideError(field);
              }}
              ref={this.selectInput}
            >
              <option />
              {options.map((option) => (
                <option key={option.Value}>{option.Name}</option>
              ))}
            </select>
            {(isChanged && error) || (backErrors && backErrors[field]) ? (
              <Errors
                category={category}
                field={field}
                frontErrors={frontErrors}
                backErrors={backErrors}
                className="error-message is-visible"
              >
                {error}
              </Errors>
            ) : (
              ""
            )}
          </div>
        )}
      </ValidationContext.Consumer>
    );
  }
}

export default control(LookUpSelect2);
